import { formatearNumeroConComas } from 'views/Components/Shared/utils/formatNumbers';

export function shortQuantity(value, field) {
	if (value >= 1000000) {
		const shortValue = value / 1000000;
		return `${formatearNumeroConComas(
			field === 'gmv_usd'
				? Math.floor(shortValue)
				: Math.floor(shortValue * 10) / 10
		)}M`;
	}

	return value;
}
